import apiFetch from "../../../shared/services/apiClient";
import { createOrGetPersona } from "./Persona";

export async function createWithPersona(
  endpoint,
  personaData,
  extrafields = {},
) {
  const personaId = await createOrGetPersona(personaData);

  const body = {
    persona: personaId,
    ...extrafields,
  };

  return apiFetch(endpoint, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
